import useWindowSize from "./useWindowSize";

interface TailwindBreakpoints {
  isXsScreen: boolean;  // < 640px
  isSmScreen: boolean;  // >= 640px
  isMdScreen: boolean;  // >= 768px
  isLgScreen: boolean;  // >= 1024px
  isXlScreen: boolean;  // >= 1280px
  is2XlScreen: boolean; // >= 1536px
}

const useTailwindBreakpoint = (): TailwindBreakpoints => {
  const { width = 0 } = useWindowSize();

  return {
    isXsScreen: width < 640,
    isSmScreen: width >= 640,
    isMdScreen: width >= 768,
    isLgScreen: width >= 1024,
    isXlScreen: width >= 1280,
    is2XlScreen: width >= 1536
  };
};

export default useTailwindBreakpoint;
